type Value = {
  building_type_id: string;
  structure_type_ids: string[];
}[];

export const buildingTypeIds = (value: Value) => {
  return value.map((value) => value.building_type_id);
};

export const addBuildingType = (value: Value, id: string) => {
  return [
    ...value,
    {
      building_type_id: id,
      structure_type_ids: [],
    },
  ];
};

export const removeBuildingType = (value: Value, id: string) => {
  return value.filter((value) => value.building_type_id !== id);
};

export const isBuildingTypeSelected = (value: Value, id: string) => {
  return value.some((value) => value.building_type_id === id);
};

export const addStructureType = (
  value: Value,
  buildingTypeId: string,
  structureTypeId: string,
) => {
  return value.map((value) => {
    if (value.building_type_id === buildingTypeId) {
      return {
        ...value,
        structure_type_ids: [...value.structure_type_ids, structureTypeId],
      };
    }
    return value;
  });
};

export const removeStructureType = (
  value: Value,
  buildingTypeId: string,
  structureTypeId: string,
) => {
  return value.map((value) => {
    if (value.building_type_id === buildingTypeId) {
      return {
        ...value,
        structure_type_ids: value.structure_type_ids.filter(
          (id) => id !== structureTypeId,
        ),
      };
    }
    return value;
  });
};
